import IConstructionOutput from "../IConstructionOutput";

export default function createConstructionOutput(): IConstructionOutput {
  return {
    id: "",
    serviceTaskTypeId: 0,
    name: "",
    shortName: ""
  };
}
